import { useReducer, useEffect } from "react";
import stepChartReducer, { combinedInitialState } from "./reducer";
import { fetchChargerMatrix } from "./api";
import ACTIONS from "./actions";
import { transformChargerData } from "../../../lib/utils/utility";

async function getChargerMatrix(dispatch, chargerId, timeRange) {
  const [startTime, endTime] = timeRange;
  dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_INIT });
  try {
    const data = await fetchChargerMatrix(chargerId, startTime?.toISOString(), endTime?.toISOString());
    if (data) {
      const dataMatrix = transformChargerData(data, startTime, endTime);
      dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_SUCCESS, payload: dataMatrix });
    } else {
      dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_FAILURE });
    }
  } catch (e) {
    console.error("error in fetching charger matrix data", e);
    dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_FAILURE });
  }
}

function useBarChartReducer({ chargerId, timeRange }) {
  const [state, dispatch] = useReducer(stepChartReducer, combinedInitialState);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (chargerId && timeRange) {
        getChargerMatrix(dispatch, chargerId, timeRange);
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [chargerId, timeRange]);

  return {
    matrix: state.matrix,
    dispatch,
  };
}

export default useBarChartReducer;
